import { styled } from "styled-components";
import { Typography } from "antd";

const ContentObjectiveStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  flex-grow: 1;
`;

const ContentTitleStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const TitleStyled = styled(Typography)`
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */

  span {
    color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  }

  &.success {
    color: ${({ theme }) => theme?.colors?.theme?.success};
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 28.8px */
  }

  &.expired-mission {
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
  }
`;

const SuccessMessageStyled = styled.div`
  display: flex;
  min-height: 480px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  p {
    color: ${({ theme }) => theme?.colors?.text?.headings};
    text-align: center; 
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }
`;

const ContentSurveyStyled = styled.div`
  width: 100%;
  height: auto;
`;


const ContentExpiredStyled = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  p{
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 24px */
  }
`;

export {
  ContentObjectiveStyled,
  TitleStyled,
  ContentTitleStyled,
  ContentSurveyStyled,
  SuccessMessageStyled,
  ContentExpiredStyled
};
